import { ModalContext } from "components/ModalContext";
import { SignInModal } from "components/Modals/SignInModal";
import { useOpinionLikeMutation } from "components/Opinion/OpinionCol/OpinionCol.hooks";
import { useUserMutation } from "components/User";
import { InInUser, UserContext } from "components/UserContext";
import { arrayRemove, arrayUnion } from "firebase/firestore";
import { useContext, useCallback } from "react";
import { toast } from "react-toastify";

export const useLike = (opinionId: string) => {
  const { open } = useContext(ModalContext);
  const { isLoading, user } = useContext(UserContext);
  const isLiked = user?.opinionLikes?.includes(opinionId) || false;
  const { mutate: updateUser } = useUserMutation();
  const { mutate: updateOpinionLike } = useOpinionLikeMutation();

  const onLikeClick = useCallback(() => {
    if (isLoading) {
      toast.info('로그인 확인 중입니다. 잠시 후 다시 시도해 주세요.');
      return false;
    }

    if (!user) {
      open(<SignInModal />);
      return false;
    }

    if (isLiked) {
      updateUser({
        opinionLikes: arrayRemove(opinionId) as unknown as InInUser['opinionLikes'],
      })
      updateOpinionLike({ opinionId, increaseCount: -1 });
    } else {
      updateUser({
        opinionLikes: arrayUnion(opinionId) as unknown as InInUser['opinionLikes'],
      })
      updateOpinionLike({ opinionId, increaseCount: 1 });
    }
  }, [isLiked, isLoading, open, opinionId, updateOpinionLike, updateUser, user]);

  return {
    isLiked,
    onLikeClick,
  }
}